import React, { useState } from 'react';
import axios from 'axios';
import './SubscribePage.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const SubscribePage: React.FC = () => {
  const [loading, setLoading] = useState<string | null>(null);
  const [error, setError] = useState('');

  const handleSubscribe = async (plan: 'monthly' | 'annual') => {
    setLoading(plan);
    setError('');
    try {
      const response = await axios.post(`${API_BASE}/subscription/create-checkout`, { plan });
      window.location.href = response.data.url;
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to start checkout. Please try again.');
      setLoading(null);
    }
  };

  return (
    <div className="subscribe-page">
      <h1>Choose Your Plan</h1>
      <p className="subtitle">Get full access to compliance screening tools.</p>

      {error && <div className="subscribe-error">{error}</div>}

      <p className="ach-note">
        We accept credit cards and ACH bank transfers.
      </p>

      <div className="plan-cards">
        <div className="plan-card">
          <h2>Monthly</h2>
          <p className="price">$250<span>/mo</span></p>
          <div className="no-savings" />
          <button
            className="subscribe-btn"
            onClick={() => handleSubscribe('monthly')}
            disabled={loading !== null}
          >
            {loading === 'monthly' ? 'Redirecting...' : 'Subscribe Monthly'}
          </button>
        </div>

        <div className="plan-card featured">
          <span className="badge">Best Value</span>
          <h2>Annual</h2>
          <p className="price">$2,500<span>/yr</span></p>
          <p className="savings">Save $500 per year</p>
          <button
            className="subscribe-btn"
            onClick={() => handleSubscribe('annual')}
            disabled={loading !== null}
          >
            {loading === 'annual' ? 'Redirecting...' : 'Subscribe Annually'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscribePage;
